const STATE = {
  version: '1.0',
  language: 'fa',
  defaultWifiPrefix: 'Luxin-',
  defaultWifiPassword: '12345678',
  themeMainColors: ['#00AEEF', '#FF946B', '#E791FF', '#F1BC52', '#56D89D', '#ECECEC'],
  themeSecondaryColors: ['#1EA5DE', '#F36C4F', '#CC77E4', '#F18228', '#3BB878', '#DEDEDE'],
  user: {
    loggedIn: false,
    uuid: null,
    loginToken: null,
    mobileNumber: null,
    isIntroTaken: false
  },
  hubs: [],
  nodes: [],
  showLuxi: true,
  widgets: [],
  schedules: [],
  notifications: [],
  scannedQR: null,
  tempHub: {
    password: null,
    name: null,
    color: null
  },
  tempNode: {
    hubIndex: null,
    name: null,
    color: null
  },
  appBusy: false,
  activeDashboardFolderId: 0,
}
export default STATE;